import { EntityLabels, ListPageTitles } from "../../utils/navigation/pageTitles";
import { WasteMovementEditPage } from "../WasteReceivedEditPage/WasteMovementEditPage";

const WasteReceivedEditPage = () => (
    <WasteMovementEditPage
        config={{
            movementDirection: "Received",
            listTitle: ListPageTitles.wasteReceived,
            entityLabel: EntityLabels.wasteReceived,
            listPath: "/waste-received",
            siteStorageKey: "WasteReceivedListPage.siteId",
        }}
    />
);

export { WasteReceivedEditPage };
